import { render, staticRenderFns } from "./IndexPuntiLuceMappa.vue?vue&type=template&id=3a526b82&scoped=true&lang=pug&"
import script from "./IndexPuntiLuceMappa.vue?vue&type=script&lang=ts&"
export * from "./IndexPuntiLuceMappa.vue?vue&type=script&lang=ts&"
import style0 from "./IndexPuntiLuceMappa.vue?vue&type=style&index=0&id=3a526b82&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a526b82",
  null
  
)

export default component.exports